<div class="form-group" [formGroup]="form">

  <label class="form-label" [for]="controlName">
    {{ label }}
    <span class="required-indicator">*</span>
  </label>

  <div class="input-wrapper" style="position: relative;">
    <input
      class="form-input"
      [id]="controlName"
      [type]="getInputType()"
      [placeholder]="type === 'phone' ? '+91 9876543210' : placeholder"
      [formControlName]="controlName"
      [class.error]="submitted && control?.invalid"
      [attr.list]="options.length > 0 ? controlName + '-list' : null"
      [readonly]="readonly"
      [style.pointer-events]="readonly ? 'none' : 'auto'"
    />
    <datalist *ngIf="options.length > 0" [id]="controlName + '-list'">
      <option *ngFor="let option of options" [value]="option"></option>
    </datalist>
    <button *ngIf="type === 'password'" type="button" class="toggle-password" (click)="toggleNewPassword()">
      <!-- Eye Icon (Visible) -->
      <svg *ngIf="!showNewPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
      </svg>
      <!-- Eye Slash Icon (Hidden) -->
      <svg *ngIf="showNewPassword" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
      </svg>
    </button>
  </div>
   <div class="error-message" *ngIf="submitted && control?.errors">
    <svg fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clip-rule="evenodd" />
    </svg>

    <span *ngIf="control?.errors?.['required']">
      {{ label }} is required
    </span>

   <span *ngIf="!control?.errors?.['required']  && control?.errors?.['pattern']">
    Please enter a valid email
  </span>

  <span *ngIf="type === 'phone' && control?.errors?.['pattern'] && !control?.errors?.['required']">
      Please enter a valid phone number with country code
    </span>

  </div>

</div>
